<div class="w-100 p-1h relative confirm-close-modal" cdkTrapFocus>
  <button type="button"
          class="reset-button absolute t-0 r-0 icon icon-close close"
          [mat-dialog-close]="false"
          data-test-id="button_close_dialog"></button>
  <div mat-dialog-title class="medium" *ngIf="header">
    <h3>{{ header }}</h3>
  </div>
  <div mat-dialog-content *ngIf="message">
    <p class="fs-md m-0 mb-2" [innerHTML]="message"></p>
  </div>
  <div mat-dialog-actions class="row w-100 d-flex no-wrap mb-0 p-0">
    <button type="button"
            *ngIf="!isCloseModal"
            data-test-id="button_confirm_close"
            class="button primary-button col mr-1"
            [mat-dialog-close]="true">{{confirmBtn || ('common.label.yes' | translate)}}</button>
    <button type="button"
            data-test-id="button_cancel_close"
            class="button secondary-button col ml-1"
            [mat-dialog-close]="false" cdkFocusInitial>{{getCloseBtnLabel}}</button>
  </div>
</div>
